import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import {
  GcButtonComponent,
  IpoLanguageService,
  IpoStringService,
  IpoTranslatePipe,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import en from '../../../../strings.en';
import fi from '../../../../strings.fi';
import sv from '../../../../strings.sv';

@Component({
  selector: 'app-popup-button-container',
  imports: [IpoTranslatePipe, GcButtonComponent],
  providers: [
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),
      deps: [IpoLanguageService],
    },
  ],
  templateUrl: './button-popup-container.component.html',
  styleUrl: './button-popup-container.component.scss',
})
export class ButtonPopupContainerComponent {
  excludePrimaryButton = input<boolean>(false);
  excludeSecondaryButton = input<boolean>(false);

  @Input() primaryButtonText: string;
  @Input() secondaryButtonText: string;

  @Output() primaryButtonClick = new EventEmitter();
  @Output() secondaryButtonClick = new EventEmitter();

  onClickPrimary() {
    this.primaryButtonClick.emit();
  }

  onClickSecondary() {
    this.secondaryButtonClick.emit();
  }
}
